import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation, Trans } from "react-i18next";
import "./ExercisePromoModal.css";

function ExercisePromoModal({ show, onHide }) {
  const { t } = useTranslation();

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="exercise-promo-modal-title"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="exercise-promo-modal-title">
          {t("exercisePromo.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="exercise-promo-content">
          <p className="exercise-promo-intro">
            {t("exercisePromo.intro")}
          </p>
          
          <div className="exercise-promo-details">
            <h5>{t("exercisePromo.howItWorks")}</h5>
            <ol>
              <li>{t("exercisePromo.step1")}</li>
              <li>{t("exercisePromo.step2")}</li>
              <li>{t("exercisePromo.step3")}</li>
              <li>{t("exercisePromo.step4")}</li>
            </ol>
          </div>

          <div className="exercise-promo-reward">
            <h5>{t("exercisePromo.reward")}</h5>
            <p>
              <Trans i18nKey="exercisePromo.rewardDescription" />
            </p>
          </div>

          <div className="exercise-promo-image">
            <img
              src="/images/exercise-release-settings.png"
              alt={t("exercisePromo.imageAlt")}
              className="img-fluid"
              style={{ maxWidth: "100%", height: "auto", border: "1px solid #e5e7e8", borderRadius: "5px" }}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="bs-button-color" onClick={handleClose}>
          {t("exercisePromo.understood")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ExercisePromoModal;

